// API配置文件 - 集中管理所有配置项
const config = {
    // API基础域名
    //apiBaseUrl: 'https://ht.3399pk.com/',//周芷若专用
    //apiBaseUrl: 'https://ht.95yw.com/',//羽人专用
    //apiBaseUrl: 'https://ht.baolv.top/',//达文西
    apiBaseUrl: 'https://ht.baolv.top/',//待定专用
    //apiBaseUrl: 'https://ht.39191.com/',
    //apiBaseUrl:'http://www.cywx.com/',
	// apiBaseUrl: 'https://ht.yueka.top/',//月卡版本专用
    //apiBaseUrl:'https://ht.3399pk.com/',
    // 可以根据需要添加其他配置项
    timeout: 30000, // 请求超时时间（毫秒）
    retryCount: 3   // 请求失败重试次数
};

export default config;